import { CoursesModel, CourseModule, Lesson } from '../../models/courses';
import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import { ModuleCreateRequest } from './dto/ModuleCreateRequest.dto';
import { ModuleReorderRequest } from './dto/ModuleReorderRequest.dto';
import { ModuleUpdateRequest } from './dto/ModuleUpdateRequest.dto';
import { LessonCreateRequest } from './dto/LessonCreateRequest.dto';
import { LessonReorderRequest } from './dto/LessonReorderRequest.dto';
import { LessonUpdateRequest } from './dto/LessonUpdateRequest.dto';

export class CoursesApi {
  // eslint-disable-next-line no-unused-vars
  constructor(private api: ApiClient) {}

  path = '/courses';

  async create(req: FormData) {
    const resp = await this.api.client.post<NiceResponse<null>>(
      this.path + '/create',
      req,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return resp.data;
  }

  async update(req: FormData, id: string) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/update/' + id,
      req,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return resp.data;
  }

  async delete(id: string) {
    const resp = await this.api.client.delete<NiceResponse<null>>(
      this.path + '/delete/' + id,
    );
    return resp.data;
  }

  async get(skip: number, take: number) {
    const resp = await this.api.client.get<NiceResponse<CoursesModel[]>>(
      this.path + '/list?skip=' + skip + '&take=' + take,
    );
    return resp.data;
  }

  // Modules

  async getModules(courseId: string) {
    const resp = await this.api.client.get<NiceResponse<CourseModule[]>>(
      `${this.path}/${courseId}/modules`,
    );
    return resp.data;
  }

  async createModule(courseId: string, req: ModuleCreateRequest) {
    const resp = await this.api.client.post<NiceResponse<null>>(
      `${this.path}/${courseId}/modules`,
      req,
    );
    return resp.data;
  }

  async updateModule(req: ModuleUpdateRequest, id: string) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/modules/' + id,
      req,
    );
    return resp.data;
  }

  async deleteModule(id: string) {
    const resp = await this.api.client.delete<NiceResponse<null>>(
      this.path + '/modules/' + id,
    );
    return resp.data;
  }

  async reorderModules(req: ModuleReorderRequest) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/modules/reorder',
      req,
    );
    return resp.data;
  }

  // Lessons

  async getLessons(moduleId: string) {
    const resp = await this.api.client.get<NiceResponse<Lesson[]>>(
      `${this.path}/modules/${moduleId}/lessons`,
    );
    return resp.data;
  }

  async createLesson(moduleId: string, req: LessonCreateRequest) {
    const resp = await this.api.client.post<NiceResponse<null>>(
      `${this.path}/modules/${moduleId}/lessons`,
      req,
    );
    return resp.data;
  }

  async updateLesson(req: LessonUpdateRequest, id: string) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/lessons/' + id,
      req,
    );
    return resp.data;
  }

  async deleteLesson(id: string) {
    const resp = await this.api.client.delete<NiceResponse<null>>(
      this.path + '/lessons/' + id,
    );
    return resp.data;
  }

  async reorderLessons(moduleId: string, req: LessonReorderRequest) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      `${this.path}/modules/${moduleId}/lessons/reorder`,
      req,
    );
    return resp.data;
  }
}
